const alphab = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
const base64Map = {};
for (let i = 0; i < alphab.length; i++) {
    base64Map[alphab[i]] = i;
}
export function encodeBase64(uint8array) {
    let icodes = 0;
    const codes = new Uint8Array(Math.ceil(uint8array.length / 3) * 4);
    for (let i = 2; i < uint8array.length; i += 3) {
        const uint24 = (uint8array[i - 2] << 16) | (uint8array[i - 1] << 8) | uint8array[i];
        codes[icodes] = alphab.codePointAt(uint24 >> 18);
        codes[icodes + 1] = alphab.codePointAt((uint24 >> 12) & 0b111111);
        codes[icodes + 2] = alphab.codePointAt((uint24 >> 6) & 0b111111);
        codes[icodes + 3] = alphab.codePointAt(uint24 & 0b111111);
        icodes += 4;
    }
    const leftovers = uint8array.length % 3;
    if (leftovers === 2) {
        const uint24 = (uint8array[uint8array.length - 2] << 16) |
            (uint8array[uint8array.length - 1] << 8);
        codes[codes.length - 1] = 61;
        codes[codes.length - 2] = alphab.codePointAt((uint24 >> 6) & 0b111111);
        codes[codes.length - 3] = alphab.codePointAt((uint24 >> 12) & 0b111111);
        codes[codes.length - 4] = alphab.codePointAt(uint24 >> 18);
    }
    else if (leftovers === 1) {
        const uint24 = uint8array[uint8array.length - 1] << 16;
        codes[codes.length - 1] = 61;
        codes[codes.length - 2] = 61;
        codes[codes.length - 3] = alphab.codePointAt((uint24 >> 12) & 0b111111);
        codes[codes.length - 4] = alphab.codePointAt(uint24 >> 18);
    }
    return new TextDecoder("ascii").decode(codes);
}
export function decodeBase64(base64) {
    const base64Length = base64.length;
    const padding = base64.endsWith("==") ? 2 : base64.endsWith("=") ? 1 : 0;
    const uint8array = new Uint8Array((base64Length * 3) / 4 - padding);
    let iUint8 = 0;
    for (let i = 0; i < base64Length; i += 4) {
        const uint24 = (base64Map[base64[i]] << 18) |
            (base64Map[base64[i + 1]] << 12) |
            (base64Map[base64[i + 2]] << 6) |
            base64Map[base64[i + 3]];
        uint8array[iUint8] = (uint24 >> 16) & 0xff;
        if (iUint8 + 1 < uint8array.length) {
            uint8array[iUint8 + 1] = (uint24 >> 8) & 0xff;
        }
        if (iUint8 + 2 < uint8array.length) {
            uint8array[iUint8 + 2] = uint24 & 0xff;
        }
        iUint8 += 3;
    }
    return uint8array;
}
